var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "mb-2 condition-wrapper pt-2 align-items-center" },
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c("segment-name-input", {
                attrs: {
                  data: _vm.segments,
                  value: _vm.nameValueString,
                  index: _vm.index,
                },
                on: { change: _vm.handleNameChange },
              }),
              _vm._v(" "),
              _c("segment-operator-input", {
                attrs: {
                  data: _vm.segmentOptions.operators,
                  value: _vm.operator,
                  index: _vm.index,
                  "value-type": _vm.segmentOptions.valueType,
                },
                on: { change: _vm.handleOperatorChange },
              }),
              _vm._v(" "),
              _c("segment-value-input", {
                attrs: {
                  $v: _vm.$v,
                  data: _vm.multiOptionData,
                  values: _vm.values,
                  index: _vm.index,
                  "input-type": _vm.inputType,
                  "value-type": _vm.segmentOptions.valueType,
                  "condition-name":
                    _vm.segmentOptions.value || _vm.segmentOptions.name,
                },
                on: { change: _vm.handleValueChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.canDelete
        ? _c(
            "b-col",
            { staticClass: "mb-2", attrs: { cols: "1" } },
            [
              _c(
                "inline-prompt",
                {
                  staticClass: "clickable d-flex flex-row justify-content-end",
                  staticStyle: { "font-size": "0.8rem" },
                  attrs: {
                    "action-type": "delete",
                    placement: "left",
                    "confirmation-text": _vm.$t("global.actions.confirmDelete"),
                  },
                  on: { accept: _vm.handleDelete },
                },
                [_c("i", { staticClass: "fa fa-trash text-danger" })]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }